export const audioGrades = {
  All: 'all',
  Ungraded: 'ungraded',
  Approved: 'approved',
  Rejected: 'rejected',
};
